import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import CommonButton, { BUTTON_STYLES } from '../../../../components/common-button/CommonButton';
import Icon from '../../../../icons/Icon';
import { ICONS } from '../../../../icons';
import WithLabel, { LABEL_STYLES } from '../../../../components/with-label/WithLabel';
import { Input } from '../../../../components/common-inputs';
import CopyButton from '../../../../components/copy-button/CopyButton';

import scss from './PublicLinks.module.scss';

function PublicLinks({ displayLink, downloadLink }) {
  const { t } = useTranslation('activ8');
  const [isOpen, setIsOpen] = useState(false);

  const handleToggleVisibility = () => {
    setIsOpen((prevState) => !prevState);
  };

  const handleCopyLink = (link) => {
    navigator.clipboard.writeText(link);
  };

  if (!displayLink && !downloadLink) {
    return null;
  }

  return (
    <div className={scss.wrapper}>
      {isOpen ? (
        <div className={scss.links}>
          {displayLink ? (
            <WithLabel label={t('display')} variant={LABEL_STYLES.ROW} isBold isTwoDots maxWidth={400}>
              <div className={scss.inputWrapper}>
                <Input size='sm' value={displayLink} isReadOnly />
                <CopyButton onClick={() => handleCopyLink(displayLink)} />
              </div>
            </WithLabel>
          ) : null}
          {downloadLink ? (
            <WithLabel label={t('download')} variant={LABEL_STYLES.ROW} isBold isTwoDots maxWidth={400}>
              <div className={scss.inputWrapper}>
                <Input size='sm' value={downloadLink} isReadOnly />
                <CopyButton onClick={() => handleCopyLink(downloadLink)} />
              </div>
            </WithLabel>
          ) : null}
        </div>
      ) : null}

      <CommonButton styleColor={BUTTON_STYLES.PRIMARY} onClick={handleToggleVisibility} isStrokeIcon maxWidth={160}>
        <Icon icon={isOpen ? ICONS.EyeCrossed : ICONS.Eye} disableCommonColors />
        {t('publicLinks')}
      </CommonButton>
    </div>
  );
}

export default PublicLinks;
